// Basic-Theme options
const baseThemeOptions = {
  palette: {
    text: {
      primary: "#303030",
      secondary: "#637286",
    },
  },
  components: {
    MuiLink: {
      styleOverrides: {
        root: {
          fontFamily: "wbs-Source-Sans-3",
          textDecoration: "underline",
        },
      },
    },
  },
  typography: {
    fontFamily: "wbs-Source-Sans-3",
    button: {
      fontFamily: "wbs-GeneralSans",
    },
    h1: { fontFamily: "wbs-GeneralSans" },
    h2: { fontFamily: "wbs-GeneralSans" },
    h3: { fontFamily: "wbs-GeneralSans" },
    h4: { fontFamily: "wbs-GeneralSans" },
    h5: { fontFamily: "wbs-GeneralSans" },
    h6: { fontFamily: "wbs-GeneralSans" },
  },
};

export default baseThemeOptions;
